// extracted by mini-css-extract-plugin
export default {"header":"onfido-sdk-ui-ActiveVideo-Header-header","title":"onfido-sdk-ui-ActiveVideo-Header-title","subtitle":"onfido-sdk-ui-ActiveVideo-Header-subtitle"};